import { render, staticRenderFns } from "./myCourseList.vue?vue&type=template&id=96fc4e2a&scoped=true"
import script from "./myCourseList.vue?vue&type=script&lang=js"
export * from "./myCourseList.vue?vue&type=script&lang=js"
import style0 from "./myCourseList.vue?vue&type=style&index=0&id=96fc4e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fc4e2a",
  null
  
)

export default component.exports